<template>
  <!-- <div
    role="button"
    class="aup-base-arrow-growing py-2 px-4 t-heavy h5 position-relative"
    :class="{
        'solid-orange': (filled && color == 'orange' && !isDisabled),
        'solid-black': (filled && color == 'black' && !isDisabled),
        'solid-white': (filled && color == 'white' && !isDisabled),
        'solid-gray': (filled && isDisabled),
        'no-padding': (noPadding),
    }"
  >
    <slot />
    <div class="aup-base-arrow-growing__slider"></div>
    <svg
      class="aup-base-arrow-growing__arrow d-block"
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="10"
      :style="{fill: currentFillColor}"
    >
      <path :style="{stroke: currentStrokeColor}" d="M0 5h56.8" />
      <path d="M55.4 10L64 5l-8.6-5z" />
    </svg>
  </div>-->
  <div class="aup-base-arrow-growing py-2 px-4 t-heavy h5 position-relative" role="button">
    <div class="aup-base-arrow-growing__slider">
      <svg
        class="aup-base-arrow-growing__arrow d-block"
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="10"
        :style="{fill: currentFillColor}"
      >
        <path :style="{stroke: currentStrokeColor}" d="M0 5h56.8" />
        <path d="M55.4 10L64 5l-8.6-5z" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseGrowingCenteredArrow",
  props: {
    color: {
      default: "orange",
      type: String
    },
    hover: {
      type: Boolean,
      default: false
    },
    filled: {
      default: true,
      type: Boolean
    },
    currentFillColor: {
      default: "orange",
      type: String
    },
    currentStrokeColor: {
      default: "orange",
      type: String
    },
    isDisabled: {
      default: false,
      type: Boolean
    },
    noPadding: {
      default: false,
      type: Boolean
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/all.scss";
.aup-base-arrow-growing {
  margin-left: 32px;
  position: relative;
  display: inline-block;
  height: 10px;
  width: 64px;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
    &__slider {
      left: 0;
      transition-delay: 0.4s;
    }
  }

  $baseButtonLightGray: $gray-400;
  $baseButtonDarkGray: $gray-400;
  $baseButtonOrange: $primary;
  $baseButtonBlack: $sony-black;
  $baseButtonWhite: $sony-white;

  &.solid-orange {
    background: $primary;
    border-color: $primary;
  }
  &.solid-black {
    background: $baseButtonBlack;
    border-color: $baseButtonBlack;
  }
  &.solid-white {
    background: $baseButtonWhite;
    color: $baseButtonBlack;
    border-color: $baseButtonWhite;
  }
  &.solid-gray {
    background: $baseButtonLightGray;
    border-color: $baseButtonLightGray;
    pointer-events: none;
    &:hover {
      cursor: default;
      opacity: 1;
    }
    &:focus {
      outline: 0;
    }
  }

  &.no-padding {
    padding: 0 !important;
  }
  &__slider {
    position: absolute;
    left: -32px;
    top: 50%;
    transform: translateY(-50%);
    transition: left 0.3s ease-out;
  }
  &__arrow {
    stroke-miterlimit: 500;
  }
}
</style>



